
export const formatRib = (rib: string | null | undefined): string => {
  
    if(!rib) return 'XXX';
    
    // Extract the first 4 and last 4 characters
    const firstPart = rib.slice(0, 4);
    const lastPart = rib.slice(-4);
  
    // Combine them with 'xxx' in between
    return `${firstPart}xxx${lastPart}`;
};